// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var IPermissions;
(function (IPermissions) {
    IPermissions["ADMIN_USER"] = "admin-user";
    IPermissions["TENANT_CREATE"] = "tenant-create";
    IPermissions["TENANT_READ"] = "tenant-read";
    IPermissions["TENANT_WRITE"] = "tenant-write";
    IPermissions["ELECTION_EVENT_CREATE"] = "election-event-create";
    IPermissions["ELECTION_EVENT_READ"] = "election-event-read";
    IPermissions["ELECTION_EVENT_WRITE"] = "election-event-write";
    IPermissions["ELECTION_EVENT_DELETE"] = "election-event-delete";
    IPermissions["ELECTION_EVENT_ARCHIVE"] = "election-event-archive";
    IPermissions["VOTER_CREATE"] = "voter-create";
    IPermissions["VOTER_READ"] = "voter-read";
    IPermissions["VOTER_WRITE"] = "voter-write";
    IPermissions["USER_CREATE"] = "user-create";
    IPermissions["USER_READ"] = "user-read";
    IPermissions["USER_WRITE"] = "user-write";
    IPermissions["USER_PERMISSION_CREATE"] = "user-permission-create";
    IPermissions["USER_PERMISSION_READ"] = "user-permission-read";
    IPermissions["USER_PERMISSION_WRITE"] = "user-permission-write";
    IPermissions["ROLE_CREATE"] = "role-create";
    IPermissions["ROLE_READ"] = "role-read";
    IPermissions["ROLE_WRITE"] = "role-write";
    IPermissions["ROLE_ASSIGN"] = "role-assign";
    IPermissions["template_CREATE"] = "communication-template-create";
    IPermissions["template_READ"] = "communication-template-read";
    IPermissions["template_WRITE"] = "communication-template-write";
    IPermissions["NOTIFICATION_READ"] = "notification-read";
    IPermissions["NOTIFICATION_WRITE"] = "notification-write";
    IPermissions["NOTIFICATION_SEND"] = "notification-send";
    IPermissions["AREA_READ"] = "area-read";
    IPermissions["AREA_WRITE"] = "area-write";
    IPermissions["ELECTION_STATE_WRITE"] = "election-state-write";
    IPermissions["ELECTION_TYPE_CREATE"] = "election-type-create";
    IPermissions["ELECTION_TYPE_READ"] = "election-type-read";
    IPermissions["ELECTION_TYPE_WRITE"] = "election-type-write";
    IPermissions["VOTING_CHANNEL_READ"] = "voting-channel-read";
    IPermissions["VOTING_CHANNEL_WRITE"] = "voting-channel-write";
    IPermissions["TRUSTEE_CREATE"] = "trustee-create";
    IPermissions["TRUSTEE_READ"] = "trustee-read";
    IPermissions["TRUSTEE_WRITE"] = "trustee-write";
    IPermissions["TRUSTEE_CEREMONY"] = "trustee-ceremony";
    IPermissions["TALLY_READ"] = "tally-read";
    IPermissions["TALLY_START"] = "tally-start";
    IPermissions["TALLY_WRITE"] = "tally-write";
    IPermissions["TALLY_SHEET_VIEW"] = "tally-sheet-view";
    IPermissions["TALLY_SHEET_CREATE"] = "tally-sheet-create";
    IPermissions["TALLY_SHEET_PUBLISH"] = "tally-sheet-publish";
    IPermissions["TALLY_SHEET_DELETE"] = "tally-sheet-delete";
    IPermissions["TALLY_RESULTS_READ"] = "tally-results-read";
    IPermissions["PUBLISH_READ"] = "publish-read";
    IPermissions["PUBLISH_WRITE"] = "publish-write";
    IPermissions["LOGS_READ"] = "logs-read";
    IPermissions["KEYS_READ"] = "keys-read";
    IPermissions["TASKS_READ"] = "tasks-read";
    IPermissions["DOCUMENT_UPLOAD"] = "document-upload";
    IPermissions["DOCUMENT_DOWNLOAD"] = "document-download";
    IPermissions["ADMIN_CEREMONY"] = "admin-ceremony";
    IPermissions["ADMIN_DASHBOARD_VIEW"] = "admin-dashboard-view";
    IPermissions["MONITORING_DASHBOARD_VIEW_ELECTION_EVENT"] = "monitoring-dashboard-view-election-event";
    IPermissions["MONITORING_DASHBOARD_VIEW_ELECTION"] = "monitoring-dashboard-view-election";
    IPermissions["CAST_VOTE_READ"] = "cast-vote-read";
    IPermissions["DOCUMENT_READ"] = "document-read";
    IPermissions["DOCUMENT_WRITE"] = "document-write";
    IPermissions["SUPPORT_MATERIAL_READ"] = "support-material-read";
    IPermissions["SUPPORT_MATERIAL_WRITE"] = "support-material-write";
    IPermissions["MIRU_CREATE"] = "miru-create";
    IPermissions["MIRU_DOWNLOAD"] = "miru-download";
    IPermissions["MIRU_SEND"] = "miru-send";
    IPermissions["MIRU_SIGN"] = "miru-sign";
    IPermissions["CONTEST_WRITE"] = "contest-write";
    IPermissions["CONTEST_READ"] = "contest-read";
    IPermissions["CONTEST_CREATE"] = "contest-create";
    IPermissions["CONTEST_DELETE"] = "contest-delete";
    IPermissions["CANDIDATE_WRITE"] = "candidate-write";
    IPermissions["CANDIDATE_READ"] = "candidate-read";
    IPermissions["CANDIDATE_CREATE"] = "candidate-create";
    IPermissions["CANDIDATE_DELETE"] = "candidate-delete";
    IPermissions["PERMISSION_LABEL_WRITE"] = "permission-label-write";
    IPermissions["SCHEDULED_EVENT_WRITE"] = "scheduled-event-write";
    IPermissions["REPORT_READ"] = "report-read";
    IPermissions["REPORT_WRITE"] = "report-write";
    IPermissions["CLOUDFLARE_WRITE"] = "cloudflare-write";
    IPermissions["GOLD_PERMISSION"] = "gold";
    IPermissions["ELECTION_CREATE"] = "election-create";
    IPermissions["ELECTION_READ"] = "election-read";
    IPermissions["ELECTION_WRITE"] = "election-write";
    IPermissions["ELECTION_DELETE"] = "election-delete";
    IPermissions["SILVER_PERMISSION"] = "silver";
    IPermissions["ELECTION_EVENT_DATA_TAB"] = "election-event-data-tab";
    IPermissions["ELECTION_EVENT_VOTERS_TAB"] = "election-event-voters-tab";
    IPermissions["ELECTION_EVENT_AREAS_TAB"] = "election-event-areas-tab";
    IPermissions["ELECTION_EVENT_KEYS_TAB"] = "election-event-keys-tab";
    IPermissions["ELECTION_EVENT_TALLY_TAB"] = "election-event-tally-tab";
    IPermissions["ELECTION_EVENT_PUBLISH_TAB"] = "election-event-publish-tab";
    IPermissions["ELECTION_EVENT_TASKS_TAB"] = "election-event-tasks-tab";
    IPermissions["ELECTION_EVENT_LOGS_TAB"] = "election-event-logs-tab";
    IPermissions["ELECTION_EVENT_SCHEDULED_TAB"] = "election-event-scheduled-tab";
    IPermissions["ELECTION_EVENT_REPORTS_TAB"] = "election-event-reports-tab";
    IPermissions["ELECTION_EVENT_APPROVALS_TAB"] = "election-event-approvals-tab";
    IPermissions["ELECTION_DATA_TAB"] = "election-data-tab";
    IPermissions["ELECTION_APPROVALS_TAB"] = "election-approvals-tab";
    IPermissions["ELECTION_VOTERS_TAB"] = "election-voters-tab";
    IPermissions["ELECTION_PUBLISH_TAB"] = "election-publish-tab";
    IPermissions["USERS_MENU"] = "users-menu";
    IPermissions["SETTINGS_MENU"] = "settings-menu";
    IPermissions["TEMPLATES_MENU"] = "templates-menu";
    IPermissions["SETTINGS_ELECTION_TYPES_TAB"] = "settings-election-types-tab";
    IPermissions["SETTINGS_VOTING_CHANNELS_TAB"] = "settings-voting-channels-tab";
    IPermissions["SETTINGS_TEMPLATES_TAB"] = "settings-templates-tab";
    IPermissions["SETTINGS_LANGUAGES_TAB"] = "settings-languages-tab";
    IPermissions["SETTINGS_LOCALIZATION_TAB"] = "settings-localization-tab";
    IPermissions["SETTINGS_LOOK_FEEL_TAB"] = "settings-look-feel-tab";
    IPermissions["SETTINGS_TRUSTEES_TAB"] = "settings-trustees-tab";
    IPermissions["SETTINGS_COUNTRIES_TAB"] = "settings-countries-tab";
    IPermissions["MONITOR_AUTHENTICATED_VOTERS"] = "monitor-authenticated-voters";
    IPermissions["MONITOR_ALL_APPROVE_DISAPPROVE_VOTERS"] = "monitor-all-approve-disapprove-voters";
    IPermissions["MONITOR_AUTOMATIC_APPROVE_DISAPPROVE_VOTERS"] = "monitor-automatic-approve-disapprove-voters";
    IPermissions["MONITOR_MANUALLY_APPROVE_DISAPPROVE_VOTERS"] = "monitor-manually-approve-disapprove-voters";
    IPermissions["MONITOR_ENROLLED_OVERSEAS_VOTERS"] = "monitor-enrolled-overseas-voters";
    IPermissions["MONITOR_POSTS_ALREADY_CLOSED_VOTING"] = "monitor-posts-already-closed-voting";
    IPermissions["MONITOR_POSTS_ALREADY_GENERATED_ELECTION_RESULTS"] = "monitor-posts-already-generated-election-results";
    IPermissions["MONITOR_POSTS_ALREADY_OPENED_VOTING"] = "monitor-posts-already-opened-voting";
    IPermissions["MONITOR_POSTS_ALREADY_STARTED_COUNTING_VOTES"] = "monitor-posts-already-started-counting-votes";
    IPermissions["MONITOR_POSTS_INITIALIZED_THE_SYSTEM"] = "monitor-posts-initialized-the-system";
    IPermissions["MONITOR_POSTS_STARTED_VOTING"] = "monitor-posts-started-voting";
    IPermissions["MONITOR_POSTS_TRANSMITTED_RESULTS"] = "monitor-posts-transmitted-results";
    IPermissions["MONITOR_VOTERS_VOTED_TEST_ELECTION"] = "monitor-voters-voted-test-election";
    IPermissions["MONITOR_VOTERS_WHO_VOTED"] = "monitor-voters-who-voted";
    IPermissions["APPLICATION_READ"] = "application-read";
    IPermissions["APPLICATION_WRITE"] = "application-write";
    IPermissions["EE_VOTERS_COLUMNS"] = "ee-voters-columns";
    IPermissions["EE_VOTERS_FILTERS"] = "ee-voters-filters";
    IPermissions["EE_VOTERS_LOGS"] = "ee-voters-logs";
    IPermissions["VOTER_IMPORT"] = "voter-import";
    IPermissions["VOTER_EXPORT"] = "voter-export";
    IPermissions["VOTER_DELETE"] = "voter-delete";
    IPermissions["VOTER_MANUALLY_VERIFY"] = "voter-manually-verify";
    IPermissions["VOTER_CHANGE_PASSWORD"] = "voter-change-password";
    IPermissions["EE_LOCALIZATION_SELECTOR"] = "election-event-localization-selector";
    IPermissions["LOCALIZATION_CREATE"] = "localization-create";
    IPermissions["LOCALIZATION_READ"] = "localization-read";
    IPermissions["LOCALIZATION_WRITE"] = "localization-write";
    IPermissions["LOCALIZATION_DELETE"] = "localization-delete";
    IPermissions["AREA_CREATE"] = "area-create";
    IPermissions["AREA_DELETE"] = "area-delete";
    IPermissions["AREA_EXPORT"] = "area-export";
    IPermissions["AREA_IMPORT"] = "area-import";
    IPermissions["AREA_UPSERT"] = "area-upsert";
    IPermissions["EE_AREAS_COLUMNS"] = "election-event-areas-columns";
    IPermissions["EE_AREAS_FILTERS"] = "election-event-areas-filters";
    IPermissions["EE_TASKS_BACK_BUTTON"] = "election-event-tasks-back-button";
    IPermissions["EE_TASKS_COLUMNS"] = "election-event-tasks-columns";
    IPermissions["EE_TASKS_FILTERS"] = "election-event-tasks-filters";
    IPermissions["TASKS_EXPORT"] = "task-export";
    IPermissions["LOGS_EXPORT"] = "logs-export";
    IPermissions["EE_LOGS_COLUMNS"] = "election-event-logs-columns";
    IPermissions["EE_LOGS_FILTERS"] = "election-events-logs-filters";
    IPermissions["EE_SCHEDULED_EVENT_COLUMNS"] = "election-event-scheduled-event-columns";
    IPermissions["SCHEDULED_EVENT_CREATE"] = "scheduled-event-create";
    IPermissions["SCHEDULED_EVENT_DELETE"] = "scheduled-event-delete";
    IPermissions["EE_REPORTS_COLUMNS"] = "election-event-reports-columns";
    IPermissions["REPORT_CREATE"] = "report-create";
    IPermissions["REPORT_DELETE"] = "report-delete";
    IPermissions["REPORT_GENERATE"] = "report-generate";
    IPermissions["REPORT_PREVIEW"] = "report-preview";
    IPermissions["TRANSMISSION_REPORT_GENERATE"] = "transmission-report-generate";
    IPermissions["EE_PUBLISH_PREVIEW"] = "election-event-publish-preview";
    IPermissions["EE_PUBLISH_BACK_BUTTON"] = "election-event-publish-back-button";
    IPermissions["EE_PUBLISH_COLUMNS"] = "election-event-publish-columns";
    IPermissions["EE_PUBLISH_FILTERS"] = "election-event-publish-filters";
    IPermissions["PUBLISH_CREATE"] = "publish-create";
    IPermissions["PUBLISH_REGENERATE"] = "publish-regenerate";
    IPermissions["PUBLISH_EXPORT"] = "publish-export";
    IPermissions["PUBLISH_START_VOTING"] = "publish-start-voting";
    IPermissions["PUBLISH_PAUSE_VOTING"] = "publish-pause-voting";
    IPermissions["PUBLISH_STOP_VOTING"] = "publish-stop-voting";
    IPermissions["PUBLISH_CHANGES"] = "publish-changes";
    IPermissions["EE_PUBLISH_VIEW"] = "election-event-publish-view";
    IPermissions["EE_KEYS_COLUMNS"] = "election-event-keys-columns";
    IPermissions["CREATE_CEREMONY"] = "create-ceremony";
    IPermissions["EXPORT_CEREMONY"] = "export-ceremony";
    IPermissions["APPLICATION_EXPORT"] = "application-export";
    IPermissions["APPLICATION_IMPORT"] = "application-import";
    IPermissions["TRUSTEES_EXPORT"] = "trustees-export";
    IPermissions["EE_TALLY_COLUMNS"] = "election-event-tally-columns";
    IPermissions["EE_TALLY_BACK_BUTTON"] = "election-event-tally-back-button";
    IPermissions["TRANSMITION_CEREMONY"] = "transmition-ceremony";
    IPermissions["ADMIN_IP_ADDRESS_VIEW"] = "admin-ip-address-view";
    IPermissions["ELECTION_IP_ADDRESS_VIEW"] = "election-ip-address-view";
    IPermissions["ELECTION_DASHBOARD_TAB"] = "election-dashboard-tab";
    IPermissions["USER_IMPORT"] = "user-import";
    IPermissions["VOTER_VOTED_EDIT"] = "voter-voted-edit";
    IPermissions["VOTER_EMAIL_TLF_EDIT"] = "voter-email-tlf-edit";
})(IPermissions || (IPermissions = {}));
